"use client";

import React, { useState } from "react";

import { useTranslation } from "~/app/hooks/useTranslation";
import HeroCarousel from "~/common/components/HeroCarousel";
import SectionWrapper from "~/common/components/SectionWrapper";
import TestimonialCard from "~/common/components/TestimonialCard";
import { getTestimonials } from "~/common/data/testimonials";

import styles from "./SectionCarousel.module.scss";
export default function SectionCarousel() {
  const { t } = useTranslation();
  const [selectedIndex, setSelectedIndex] = useState(0);

  const testimonials = getTestimonials(t);

  return (
    <SectionWrapper background={"/marketing/heroCarousel.jpg"} className={styles.section}>
      <HeroCarousel selectedIndex={selectedIndex} onSlideChange={setSelectedIndex}>
        {testimonials.map((t) => (
          <TestimonialCard key={t.id} {...t} />
        ))}
      </HeroCarousel>
    </SectionWrapper>
  );
}
